<template>
  <v-dialog
    width="700"
    persistent
    transition="slide-x-transition"
    v-model="get_modal_view_obra"
  >
    <v-card class="expande-horizontal wrap">
      <div class="expande-horizontal px-1 pr-3 py-3">
        <v-btn dark @click="fecha_modal_view_obra" icon>
          <v-icon color="grey">
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <span style="font-size: 17pt; width: 100%;" class="fonte">
          Registro de obra
        </span>
        <div class="expande-horizontal"></div>
        <v-btn class="elevation-3" icon @click="fecha_modal_view_obra">
          <v-icon color="red">
            mdi-close
          </v-icon>
        </v-btn>
      </div>

      <div class="expande-horizontal wrap py-6 pb-0">
        <v-flex xs12>
          <v-form ref="form">
            <v-flex id="adicionar-nome-obra" class="px-3" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Obra
              </span>
              <v-text-field
                v-model="get_obra.nome"
                dense
                solo
                flat
                outlined
                clearable
                :color="$theme.primary"
                :rules="[v => !!v || 'Preencha este campo']"
                label="ex: Hospital"
              ></v-text-field>
            </v-flex>

            <v-flex class="px-3" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Cômodos
              </span>
              <v-combobox
                v-model="get_obra.comodos"
                dense
                solo
                chips
                multiple
                clear-icon="mdi-close-circle"
                flat
                outlined
                clearable
                hint="Pressione enter para adicionar um novo"
                :color="$theme.primary"
                label=""
              ></v-combobox>
            </v-flex>

            <v-flex class="px-3" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Observações
              </span>
              <v-textarea
                v-model="get_obra.obs"
                dense
                solo
                flat
                outlined
                clearable
                :color="$theme.primary"
                label=""
              ></v-textarea>
            </v-flex>


          </v-form>
        </v-flex>
      </div>

      <div class="expande-horizontal">
        <v-btn id="salvar-obra" large dark @click="valida_form" tile block color="green">
          <span class="fonte"> Salvar </span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalSendArchive from "../../shared/components/ModalSendArchive.vue";
export default {
  components: { ModalSendArchive },
  computed: {
    ...mapGetters(["get_obra", "get_modal_view_obra", "getLoggedUser"])
  },
  methods: {
    ...mapActions([
      "criar_obra",
      "atualizar_obra",
      "fecha_modal_view_obra"
    ]),
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_obra._id ? this.atualizar_obra() : this.criar_obra(true);
        setTimeout(() => {
          this.$emit("saved");
        }, 800);
      }
    }
  }
};
</script>
